/** Created by azhou on 2019/4/1.*/
<template>
    <div>
        <ul class="list-item">
            <li class="w-50 list-item-col">{{Itemize.hotelTitle}}</li>
            <li class="w-50 list-item-col">{{Itemize.title}}</li>
            <li class="w-50 list-item-col">{{Itemize.startdate | formatTimestamp(1)}}</li>
            <li class="w-50 list-item-col">{{Itemize.enddate | formatTimestamp(1)}}</li>
            <li class="w-50 list-item-col">{{Itemize.time | formatTimestamp(1)}}</li>
            <li class="w-50 list-item-col text-link" @click="Seek(Itemize.id)">查看</li>
        </ul>
        <el-dialog
            :title="'状态:'+Status"
            :visible.sync="dialogVisible">
            <p class="d-center-start mb-2">
                <left-text leftText="标题"/><span class="ml-1">{{content.title}}</span>
            </p>
            <p class="d-center-start mb-2">
                <left-text leftText="活动时间"/><span class="ml-1">{{content.startdate | formatTimestamp}} ~ {{content.enddate | formatTimestamp}}</span>
            </p>
            <div class="d-start-around mb-2">
                <left-text leftText="活动内容"/><p class="w-100 ml-1 text-left" v-html="content.content"></p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
  
</template>

<script>

  export default {
    name: 'Activities',
    props:{
      Itemize:{}
    },
    computed: {
        Status () {
            switch (this.content.status) {
                case 0: return '未审核';break;
                case 1: return '已审核';break;
            }
        }
    },
    data () {
        return {
            dialogVisible: false,
            content: {}
        }
    },
    methods: {
        async Seek (id) {
            let res = await this.$axios.post('pc/Admin/adminShowHotelActiveMess',{
                id,
                storeId: this.$route.query.id,
            });
            if (res.code === '00000') {
                this.content = res.info
                this.dialogVisible = true
            }
        }
    }
  }
</script>
